import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/useAuth";
import { apiGet, getApiErrorMessage } from "@/api";
import { tokenQuery } from "./query-options";

export interface CaptureItem {
  id: string;
  sourceUrl: string | null;
  provider: string;
  externalId: string;
  isDuplicate: boolean;
  capturedAt: string;
}

/**
 * `limit` and `teamWide` are part of the key, not just the URL: they change WHICH captures come
 * back, so a shared key would serve a personal list where the team-wide one was asked for.
 */
export function capturesQueryOptions(token: string | null, limit = 50, teamWide = false) {
  return tokenQuery(["captures", limit, teamWide], token, async (t) => {
    const params = new URLSearchParams({ limit: String(limit) });
    if (teamWide) params.set("team", "true");
    const res = await apiGet<{ captures?: CaptureItem[]; nextCursor?: string }>(
      `/captures?${params.toString()}`,
      t
    );
    if (!res.ok) throw new Error(getApiErrorMessage(res, "Captures konnten nicht geladen werden"));
    return {
      captures: res.data.captures ?? [],
      nextCursor: res.data.nextCursor,
    };
  });
}

export function useCaptures(limit = 50, teamWide = false) {
  const { state } = useAuth();
  const token = state.status === "authenticated" ? state.token : null;
  return useQuery(capturesQueryOptions(token, limit, teamWide));
}
